import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Register from '../views/Register.vue'
import ListarCollegiados from '../views/collegiates/ListarCollegiados.vue'
import AddCollegiate from '../views/collegiates/AddCollegiate.vue'
import Login from '../views/collegiates/Login.vue'

const routes = [
  {
    path: '/',
    name: 'registrar',
    component: AddCollegiate
  },

  {
    path: '/listarColegiados',
    name: '/listarColegiados',
    component: ListarCollegiados,
    meta: { requiresAuth: true }
  },

  { path: '/login', component: Login },
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.meta.requiresAuth && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router
